import React from 'react';

import { AuthLayout } from '../../../components/Layout/AuthLayout';
import SignInForm from './SignInForm';
import SignInWrapper from './SignInWrapper';

const SignIn = () => {
  return (
    <AuthLayout
      label="Don't have an account?"
      linkTitle='Sign up'
      linkPath='/account/signup'
    >
      <SignInWrapper
        formHeaderTitle='Get Started on Logirate'
        formHeaderDescription='Login to your registered Logirate account'
      >
        <SignInForm />
      </SignInWrapper>
    </AuthLayout>
  );
};

export default SignIn;
